import type { ColumnDef, FilterFn, SortingFn } from '@tanstack/vue-table';

// Extend TanStack Table types to include custom filter functions
declare module '@tanstack/vue-table' {
  interface FilterFns {
    dateRange: FilterFn<any>;
    boolean: FilterFn<any>;
    inNumberRange: FilterFn<any>;
    enumFilter: FilterFn<any>;
    iban: FilterFn<any>;
    ordersArray?: FilterFn<any>;
    arrayIncludesPartial: FilterFn<any>;
  }

  interface SortingFns {
    money: SortingFn<any>;
  }
}

export enum FilterType {
  BOOLEAN = 'boolean',
  TEXT = 'text',
  DATE = 'date',
  DATE_RANGE = 'date_range',
  NUMBER_RANGE = 'number_range',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  ARRAY = 'array',
}

export enum FieldType {
  BOOLEAN = 'boolean',
  TEXT = 'text',
  LINK_INTERNAL = 'link_internal',
  LINK_EXTERNAL = 'link_external',
  DATE = 'date',
  NUMBER = 'number',
  BADGE = 'badge',
  MONEY = 'money',
  ENUM = 'enum',
  ARRAY = 'array',
}

export type FancyTableColumnDef<T> = ColumnDef<T> & {
  fieldType?: FieldType;
  filterType?: FilterType;
  filterOptions?:
    | {
        [key: string]: string;
      }
    | Array<{ value: string; label: string }>
    | string[];
  filterValue?: any;
  hideFromColumnConfig?: boolean;
};

export interface SerializedTableState {
  columnVisibility: Record<string, boolean>;
  columnOrder: string[];
  columnSizing: Record<string, number>;
  columnPinning: {
    left: string[];
    right: string[];
  };
  columnFilters: Array<{
    id: string;
    value: any;
  }>;
  globalFilter: string;
  sorting: {
    id: string;
    desc: boolean;
  }[];
  pageSize: number;
}

export interface ServerTableOptions {
  pageIndex: number;
  pageSize: number;
  sorting: {
    id: string;
    desc: boolean;
  }[];
  filters: Array<{
    id: string;
    value: any;
  }>;
}
